export default {"src":"/_next/static/media/seo-edit-icon.7ac8d1cd.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};